import {
  presetsServiceClient,
} from '@pushwoosh/rpc-service-client/pushwoosh/presets/PresetsServiceClientPb';
import {
  Preset,
  CreatePresetRequest,
  UpdatePresetRequest,
  GetPresetRequest,
  ListPresetsRequest,
} from '@pushwoosh/rpc-service-client/pushwoosh/presets/presets_pb';
export type PresetsExportClasses = {
  PresetsServiceClient: typeof presetsServiceClient;
  Preset: typeof Preset;
  CreatePresetRequest: typeof CreatePresetRequest;
  UpdatePresetRequest: typeof UpdatePresetRequest;
  GetPresetRequest: typeof GetPresetRequest;
  ListPresetsRequest: typeof ListPresetsRequest;
};

export const presets: PresetsExportClasses = {
  PresetsServiceClient: presetsServiceClient,
  Preset,
  CreatePresetRequest,
  UpdatePresetRequest,
  GetPresetRequest,
  ListPresetsRequest,
};
